// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__hgC0U","logout":"style_logout__2M3F6","abort":"style_abort__3lBTR"};